/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { SrClass } from '@src/app/model/sr-class';

/** Service request classes - server reference data from `crm/requests/classes`. Fetched fresh each call. */
@Injectable({
    providedIn: 'root'
})
export class SrClassService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl() {
        return this.getAjaxPath('crm/requests/classes');
    }

    protected cache: SrClass[] = [];
    protected typeString = 'Request Class';
    protected hasRevision = false;
}
